/**
 * API key management for the signed-in customer.
 *
 * These calls are session-authenticated. They manage the credentials that
 * authenticate a different surface, /api/v1, which this app never calls.
 *
 * createKey is the only place the raw key value ever exists in the browser.
 * The server keeps a hash and has no endpoint that can reveal it again, so
 * whatever comes back here is the customer's single chance to copy it.
 */
import { apiFetch } from './apiClient';

export const listKeys = () => apiFetch('/api/market/api-keys');

export const createKey = (label, scopes) =>
  apiFetch('/api/market/api-keys', { method: 'POST', body: { label, scopes } });

/**
 * Change what an existing key may read. The key value is untouched, so an
 * integration already using it keeps working, with more or less authority.
 */
export const updateKeyScopes = (id, scopes) =>
  apiFetch(`/api/market/api-keys/${id}`, { method: 'PATCH', body: { scopes } });

export const revokeKey = (id) =>
  apiFetch(`/api/market/api-keys/${id}`, { method: 'DELETE' });
